import {
    Stack,
} from '@mui/material';
import * as React from 'react';
import { RowInput } from 'src/components/forms/RowInput';
import InputStyle from 'src/components/InputStyle';
import InputStyleMultline from 'src/components/InputStyleMultline';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "src/@/components/ui/select"
import { MultiSelect } from "src/@/components/ui/multi-select"
// ----------------------------------------------------------------------

export default function ChannelDirect({
    canal,
    onChange,
    onChangeAutocomplete,
    listSectors,
    listUsers,
}) {

    const usuarios = React.useMemo(() => 
        canal?.config?.direcionamento_direto?.direciona_usuario
            ?.map(id => listUsers?.find(usuario => usuario._id === id))
            ?.filter(u => u !== undefined) || []
    , [canal?.config?.direcionamento_direto?.direciona_usuario, listUsers])
    
    const setores = React.useMemo(() => 
        canal?.config?.direcionamento_direto?.direciona_setor
            ?.map(id => listSectors?.find(setor => setor._id === id))
            ?.filter(s => s !== undefined) || []
    , [canal?.config?.direcionamento_direto?.direciona_setor, listSectors])

    const usersFormatted = listUsers?.map(user => ({
        value: user._id,
        label: `${user.nomeFantasia} - ${user.nome_setor}`
    })) || []

    const sectorsFormatted = listSectors?.map(sector => ({
        value: sector._id,
        label: sector.nome_setor
    })) || []

    const usuariosIds = React.useMemo(() => usuarios?.map(u => u?._id) || [], [usuarios])
    const setoresIds = React.useMemo(() => setores?.map(s => s?._id) || [], [setores])

    return (
        <Stack direction={"column"} sx={{ mt: 2 }} spacing={3}>
            <Stack direction={"column"} spacing={2}>
                <RowInput
                    label={"status"}
                    sx={{ width: '50%' }}
                    input={
                        <Select
                            value={canal?.config?.direcionamento_direto?.statusRoom}
                            onValueChange={(value) => 
                                onChange({ target: { name: "statusRoomDirectTarget", value }})
                            }
                        >
                            <SelectTrigger>
                                <SelectValue placeholder="Selecione o status" />
                            </SelectTrigger>
                            <SelectContent>
                                <SelectItem value="Atendendo">Atendendo</SelectItem>
                                <SelectItem value="Pendente">Pendente</SelectItem>
                            </SelectContent>
                        </Select>
                    }
                />
                
                <Stack direction={"row"} spacing={2}>
                    <RowInput
                        label={"direciona usuários"}
                        sx={{ width: '100%' }}
                        input={
                            <MultiSelect
                                key={`users-${usuariosIds.join('-')}`}
                                options={usersFormatted}
                                defaultValue={usuariosIds}
                                onValueChange={(value) => 
                                    onChangeAutocomplete(null, 
                                        value.map(v => listUsers.find(u => u._id === v)), 
                                        'directTargetUser'
                                    )
                                }
                                placeholder="Selecionar usuários"
                            />
                        }
                    />

                    <RowInput
                        label={"direciona setores"}
                        sx={{ width: '100%' }}
                        input={
                            <MultiSelect
                                key={`sectors-${setoresIds.join('-')}`}
                                options={sectorsFormatted}
                                defaultValue={setoresIds}
                                onValueChange={(value) => 
                                    onChangeAutocomplete(null, 
                                        value.map(v => listSectors.find(s => s._id === v)), 
                                        'directTargetSector'
                                    )
                                }
                                placeholder="Selecionar setores"
                            />
                        }
                    />
                </Stack>
            </Stack>

            <Stack>
                <RowInput
                    label={"mensagem após direcionamento"}
                    sx={{ width: '100%' }}
                    input={<InputStyleMultline
                        autoFocus
                        type="text"
                        value={canal?.config?.direcionamento_direto?.mensagem_apos_cadastro}
                        name="directTargetMessage"
                        margin="dense"
                        variant="outlined"
                        multiline
                        rows={6}
                        onChange={onChange}
                    />}
                />
            </Stack>
        </Stack>
    );
}

